// extracted by mini-css-extract-plugin
export default {"wrapper":"app_wrapper__hxYMJ","snackbar_provider":"app_snackbar_provider__Fsj+2"};